import React from 'react';
import AppBar from '@mui/material/AppBar';
import {
  Container,
  Toolbar,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';
import Footer from './Footer.js';
import AspectRatio from '@mui/joy/AspectRatio';

function Home() {
  return (
    <>
      <div style={{ flexGrow: 1 }}>
        <AppBar>
          <Toolbar position="static">
            <>
              <Box style={{ flexGrow: 1 }}>
                <Typography variant="h6" style={{ flexGrow: 1 }}>
                  Kei-no-suke's Page
                </Typography>
                <Link
                  to={'/'}
                  style={{ marginRight: 10, padding: 2 }}
                  className="current"
                >
                  Home
                </Link>
                <Link to={'/scrap'} style={{ padding: 2 }}>
                  Scrap
                </Link>
              </Box>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <a href="https://github.com/Kei-no-suke">
                  <i className="fa-brands fa-github white-logo"></i>
                </a>
              </IconButton>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <a href="https://twitter.com/Kei_no_suke2309">
                  <i class="fa-brands fa-x-twitter white-logo"></i>
                </a>
              </IconButton>
            </>
          </Toolbar>
        </AppBar>
      </div>
      <div
        style={{ marginTop: '80px', marginLeft: '10px' }}
        className="Black_char"
      >
        <h2>制作アプリ一覧</h2>
        <h4>今後制作したアプリを掲載していく予定です。</h4>
      </div>
      <div style={{ marginLeft: '10px' }}>
        <Card sx={{ maxWidth: 345 }}>
          <AspectRatio objectFit="contain">
            <CardMedia
              component="img"
              sx={{ height: 250 }}
              image="./images/feature_graphic_todo.png"
              title="feature graphic of todo list app"
            />
          </AspectRatio>

          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              Todoリスト
            </Typography>
            <Typography variant="body2" color="text.secondary">
              広告なしのシンプルなTodoリストです。締め切り日と進捗を記録することができます。
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              size="small"
              href="https://play.google.com/store/apps/details?id=com.keinosuke.todoapplication"
              className="cardButton card_item"
            >
              Google Play
            </Button>
            <Link
              to={'/privacy_policy/todoapp'}
              style={{ padding: 2 }}
              className="card_item"
            >
              <Typography variant="body2" fontWeight="Bold">
                Privacy Policy
              </Typography>
            </Link>
          </CardActions>
        </Card>
      </div>
      <Footer />
    </>
  );
}

export default Home;
